import BookingAdministrativeInformation from "@/components/BookingsDetails/BookingAdministrativeInformation";

const StaffAdministrativeInformation = ({}) => {
    return(
        <>
        <BookingAdministrativeInformation showHeaderLabel headerLabel="Staff Administrative Information" parentKey="staff"/>
        </>
    )
}
export default StaffAdministrativeInformation;